import React from 'react';
import { HuchaVentaValues } from '../../../shared/models/hucha-values';
import { HuchaRenovadoresCard } from './hucha-renovadores-card/hucha-renovadores-card';
import { HuchaStandardCard } from './hucha-standard-card/hucha-standard-card';

export const HuchaVentaCard = ({
	huchaValues,
	bonoPosventaExists,
}: {
	huchaValues: HuchaVentaValues;
	bonoPosventaExists: boolean;
}): React.ReactElement => {
	if (huchaValues?.huchaTier !== 'standard') {
		return <HuchaRenovadoresCard huchaValues={huchaValues} bonoPosventaExists={bonoPosventaExists} />;
	}
	return <HuchaStandardCard huchaValues={huchaValues} bonoPosventaExists={bonoPosventaExists} />;
};
